<template>
<!-- Verifica se o usuário está autenticado e escolhe o layout adequado -->
<component :is="layout">
  <router-view></router-view> <!-- Renderiza as views dentro do layout -->
</component>
</template>

<script>
import { mapState } from 'vuex'; // Importando mapState do Vuex
import AuthenticatedLayout from './layouts/AuthenticatedLayout.vue';
import UnauthenticatedLayout from './layouts/UnauthenticatedLayout.vue';

export default {
  name: 'App',
  computed: {
    // Componente que define qual layout usar com base no estado de autenticação
    layout() {
      return this.isAuthenticated ? AuthenticatedLayout : UnauthenticatedLayout;
    },
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated, // Acessando o estado de autenticação do Vuex
    })
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Arial', sans-serif !important;
  background-color: #f4f4f9;
}
</style>
